var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_567_37543)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.70588,
    y: 5.70588,
    width: 22.5882,
    height: 22.5882,
    rx: 11.2941,
    stroke: "url(#paint0_linear_567_37543)",
    strokeWidth: 1.41176
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter1_b_567_37543)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 8.25,
    fill: "url(#paint1_linear_567_37543)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 7.89706,
    stroke: "url(#paint2_linear_567_37543)",
    strokeWidth: 0.705882
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.1865 16.6497C20.5303 16.8419 20.5303 17.3222 20.1865 17.5143L15.5459 20.1082C15.2021 20.3003 14.7725 20.0601 14.7725 19.6759L14.7725 14.4882C14.7725 14.1039 15.2021 13.8638 15.5459 14.0559L20.1865 16.6497Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_567_37543",
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.172549 0 0 0 0 0.172549 0 0 0 0 0.172549 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_567_37543"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_567_37543",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_567_37543",
    x: 4.33621,
    y: 4.33621,
    width: 25.3276,
    height: 25.3276,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.2069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_567_37543"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_567_37543",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_567_37543",
    x1: 17,
    y1: 5,
    x2: 17,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6941C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A461D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_567_37543",
    x1: 11.7059,
    y1: 11,
    x2: 22.2941,
    y2: 23.3529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6941C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_567_37543",
    x1: 17,
    y1: 8.75,
    x2: 17,
    y2: 25.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6941C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A461D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHPlayIcon);
export default __webpack_public_path__ + "static/media/h-play-icon.45228790bcb0da402b03aa9ddc7628c8.svg";
export { ForwardRef as ReactComponent };